export enum ErrorMessages {
  invalidIdentifier = 'Invalid identifier.',
  unexpectedError = 'An unexpected error occured.',
  eventingFallbackNotAllowed = 'Eventing Fallback was not allowed.',
  subscriberNotPersistent = 'pause and resume events are not allowed'
}
